import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Inject, NgModule } from '@angular/core';
import { __awaiter } from 'tslib';
import * as i1 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i2 from '@angular/common/http';

const SE_FE_TRANSLATIONS_BASE_PATH = new InjectionToken('SeFeTranslationsBasePath');
const SE_FE_TRANSLATIONS_PREFIX = new InjectionToken('SeFeTranslationsPrefix');
const SE_FE_TRANSLATIONS_LANGUAGES = new InjectionToken('SeFeTranslationsLanguages');

class SeFeTranslationsLoader {
    constructor(basePath, prefix, langs, translateService, http) {
        this.basePath = basePath;
        this.prefix = prefix;
        this.langs = langs;
        this.translateService = translateService;
        this.http = http;
        this.loaded = {};
        // noop
    }
    // A resolver is used to preload translations for each component, since there seems to be a bug
    // with the httpLoader that doesn't do this automatically when we extend from the parent translate
    // service. We want to track the load anyway to prevent components from trying to load before
    // the translation data is ready, so this serves both purposes.
    canActivate(router, snapshot) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.load();
            return true;
        });
    }
    // Load the language file, tracking the promise so we don't load twice, or move on early if called a second time
    load(prefix = this.prefix) {
        return __awaiter(this, void 0, void 0, function* () {
            const loaded = yield this.loaded[prefix];
            return loaded || (yield (this.loaded[prefix] = this.reload(prefix)));
        });
    }
    reload(prefix = this.prefix) {
        const success = (t) => {
            this.translateService.setTranslation(this.lang, t, true);
            return true;
        };
        const fail = (e) => {
            console.error(e);
            return false;
        };
        this.setCurrentLang();
        return this.http
            .get(`${this.basePath}/${prefix}/${this.lang}.json`)
            .toPromise()
            .then(success, fail);
    }
    setCurrentLang() {
        if (this.translateService.currentLang)
            return;
        const possibleLangs = [
            this.translateService.getBrowserCultureLang(),
            this.translateService.getBrowserLang(),
            this.translateService.defaultLang // 'en'
        ];
        while (possibleLangs.length) {
            const lang = possibleLangs.shift();
            if (this.langs.includes(lang)) {
                this.translateService.use(lang);
                return;
            }
        }
    }
    get lang() {
        return this.translateService.currentLang || this.translateService.defaultLang;
    }
}
SeFeTranslationsLoader.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTranslationsLoader, deps: [{ token: SE_FE_TRANSLATIONS_BASE_PATH }, { token: SE_FE_TRANSLATIONS_PREFIX }, { token: SE_FE_TRANSLATIONS_LANGUAGES }, { token: i1.TranslateService }, { token: i2.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
SeFeTranslationsLoader.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTranslationsLoader });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTranslationsLoader, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [SE_FE_TRANSLATIONS_BASE_PATH]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SE_FE_TRANSLATIONS_PREFIX]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [SE_FE_TRANSLATIONS_LANGUAGES]
                }] }, { type: i1.TranslateService }, { type: i2.HttpClient }]; } });

class SeFeTranslationsRootModule {
}
SeFeTranslationsRootModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTranslationsRootModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeTranslationsRootModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTranslationsRootModule, imports: [i1.TranslateModule], exports: [TranslateModule] });
SeFeTranslationsRootModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTranslationsRootModule, providers: [SeFeTranslationsLoader], imports: [[TranslateModule.forRoot({ defaultLanguage: 'en' })], TranslateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTranslationsRootModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [TranslateModule.forRoot({ defaultLanguage: 'en' })],
                    exports: [TranslateModule],
                    providers: [SeFeTranslationsLoader]
                }]
        }] });
class SeFeTranslationsChildModule {
}
SeFeTranslationsChildModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTranslationsChildModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeTranslationsChildModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTranslationsChildModule, imports: [i1.TranslateModule], exports: [TranslateModule] });
SeFeTranslationsChildModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTranslationsChildModule, providers: [SeFeTranslationsLoader], imports: [[TranslateModule.forChild({ extend: true })], TranslateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTranslationsChildModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [TranslateModule.forChild({ extend: true })],
                    exports: [TranslateModule],
                    providers: [SeFeTranslationsLoader]
                }]
        }] });
class SeFeTranslationsModule {
    static forRoot(langs, basePath = '') {
        return {
            ngModule: SeFeTranslationsRootModule,
            providers: [
                {
                    provide: SE_FE_TRANSLATIONS_LANGUAGES,
                    useValue: langs
                },
                {
                    provide: SE_FE_TRANSLATIONS_BASE_PATH,
                    useValue: basePath
                },
                {
                    provide: SE_FE_TRANSLATIONS_PREFIX,
                    useValue: 'assets/translations'
                }
            ]
        };
    }
    static forChild(name) {
        return {
            ngModule: SeFeTranslationsChildModule,
            providers: [
                {
                    provide: SE_FE_TRANSLATIONS_PREFIX,
                    useValue: `assets/${name}/translations`,
                }
            ]
        };
    }
}
SeFeTranslationsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTranslationsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeTranslationsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTranslationsModule, exports: [TranslateModule] });
SeFeTranslationsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTranslationsModule, imports: [TranslateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeTranslationsModule, decorators: [{
            type: NgModule,
            args: [{
                    exports: [TranslateModule]
                }]
        }] });

/*
 * Public API Surface of se-fe-translations
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SE_FE_TRANSLATIONS_BASE_PATH, SE_FE_TRANSLATIONS_LANGUAGES, SE_FE_TRANSLATIONS_PREFIX, SeFeTranslationsChildModule, SeFeTranslationsLoader, SeFeTranslationsModule, SeFeTranslationsRootModule };
